export default __webpack_public_path__ + "static/media/2.eba8ef60.jpg";